import React, { useRef, useState } from 'react';
import Loader from 'components/Loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEnvelope,
  faEye,
  faEyeSlash,
  faLock,
  faAddressBook,
} from '@fortawesome/free-solid-svg-icons';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useMutation } from 'react-query';
import { checkUserSignIn, signInUserApi, verifyOtpSignIn } from './services/authentication';
import { useHistory } from 'react-router-dom';
import uttarakhanadLogo from '../assets/img/logo/uttarakhanda.png';
// import KheloPanchkula from '../assets/img/logo/khelo_logo_white.png';
import KheloWhiteOutlined from '../assets/img/logo/NATIONAL GAMES LOGO_01-11.png';
import { Footer2ButtonAuth } from '../registration/Components/Footers';
import { useRedirectIfLoggedIn } from 'hooks/useRedirectIfLoggedIn';
import Analytics from '../utils/analytics';
import { useShowKhelo } from 'utils/HooksUtils';
import { OtpComponent } from './OtpComponent';
// import KheloHeader from 'micro-site/Components/KheloHeader/KheloHeader';

// import { Helmet } from 'react-helmet';

const initialValues = {
  username: '',
  otpUsername: '',
  password: '',
  otp: '',
  formMode: 'password',
  secondPage: false,
};

// const emailRegex = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
const validationSchema = Yup.object({
  username: Yup.string().when('formMode', {
    is: 'password',
    then: Yup.string().email('Invalid email').required('Kindly Enter a Valid Email ID'),
  }),
  otpUsername: Yup.string().when('formMode', {
    is: 'otp',
    then: Yup.string()
      .required('Mobile Number is required')
      .test('phone length', 'Please Enter a valid Mobile Number', (value) => {
        if (value === null && typeof value === 'undefined') return false;
        try {
          if (isNaN(value)) return false;
          return value?.toString()?.length === 10;
        } catch (e) {
          return false;
        }
      }),
  }),
  password: Yup.string().when('formMode', {
    is: 'password',
    then: Yup.string().required('Kindly Enter Your Password'),
  }),
});

export default function SignIn() {
  const isKhelo = useShowKhelo();
  const history = useHistory();
  const { refetch, isLoading } = useRedirectIfLoggedIn();
  const [error, setError] = useState(null);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const currentData = useRef(null);

  const checkUserMutation = useMutation((data) => checkUserSignIn(data), {
    onError: async (err) => {
      setError(err);
    },
  });
  const verifyOtpMutation = useMutation((data) => verifyOtpSignIn(data), {
    onError: async (err) => {
      setError(err);
    },
    onSuccess: (data) => {
      if (Analytics)
        Analytics.track('Login', {
          full_name: data?.full_name,
          email: currentData?.username,
        });
      refetch();
    },
  });
  const signInMutation = useMutation((data) => signInUserApi(data), {
    onSuccess: (data) => {
      if (Analytics)
        Analytics.track('Login', {
          full_name: data?.full_name,
          email: currentData?.username,
        });
      refetch();
    },
    onError: async (err) => {
      setError(err);
      console.debug('Error - ', err);
    },
  });
  const handleSignIn = () =>
    async function (values, { setSubmitting, setValues }) {
      setSubmitting(true);
      setError('  ');
      currentData.current = values;
      if (values.formMode === 'password') await signInMutation.mutateAsync(values);
      else {
        if (!values.secondPage) {
          await checkUserMutation.mutateAsync({ username: values.otpUsername });
          setValues({ ...values, secondPage: true });
        }
        if (values.secondPage)
          await verifyOtpMutation.mutateAsync({ username: values.otpUsername, otp: values.otp });
      }
      setSubmitting(false);
    };

  return (
    <>
      {/* <Helmet>
        <title>Sign In | KIYG Haryana 2021</title>
        <meta property="og:title" content="Sign In | KIYG Haryana 2021" />
      </Helmet> */}

      {isLoading ? (
        <div className="h-screen d-flex align-middle justify-center bg-red">
          <Loader color="purple-400" />
        </div>
      ) : (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSignIn()}
        >
          {({ isSubmitting, values, setValues, setErrors, setFieldValue }) => (
            <div className="flex flex-row w-screen h-screen">
              <div
                id={`${isKhelo ? '' : 'blue-bg'}`}
                className="hidden h-screen p-15 lg:flex lg:w-1/2 flex justify-center items-center flex-col text-left font-roboto font-bold"
              >
                <div className="p-4">
                  <img
                    src={isKhelo ? KheloWhiteOutlined : uttarakhanadLogo}
                    className="w-full"
                    alt={'sfa logo'}
                  />
                </div>
                {/* <div className="mx-20 py-6 mr-8 mb-0 right-tagline font-bold font-poppins">
            Organize,
            <br />
            Play & <br />
            Track The
            <br />
            Easy Way
          </div> */}
                {/* <div className="middle-line bg-opacity-50 w-16 ml-20 mb-10 mt-0  h-1 bg-white" />
          <p className="px-20 py-0 right-info text-left text-white">
            Organize tournaments, manage teams, score <br />
            matches & keep track of your performance in <br />
            every match you play. It's Free!
          </p> */}
              </div>
              <div
                id={`${isKhelo ? 'khelo-bg' : 'blue-bg'}`}
                className="w-full lg:w-1/2 md:bg-white md:py-0"
              >
                {
                  // <img
                  //   src={SFALogo}
                  //   alt="Sfa Play Mobile Logo"
                  //   className="block md:hidden h-12 p-2"
                  //   onClick={() => {
                  //     history.push('/');
                  //   }}
                  // />
                }
                {/* <div className="block md:hidden">
                  {isKhelo ? <KheloHeader invisibleLinks /> : null}
                </div> */}
                <div className="py-8 bg-white px-5 md:px-32 lg:px-20 xl:px-32  h-full flex flex-col md:justify-center text-left">
                  <div className="action text-xl md:text-3.5xl mb-1 md:mb-0">Sign In</div>

                  <div className="pb-4 md:pb-6 info">
                    {/* Enter the world of sports by <Link to="/signup/">creating an account</Link> with us! */}
                    <div className="flex font-roboto text-sm mt-8 gap-4">
                      <button
                        type="button"
                        className={`${
                          values.formMode === 'password'
                            ? 'bg-blue-kheloBlue text-white'
                            : 'bg-gray-100 hover:bg-orange-350 hover:text-white'
                        }  p-2 rounded-md w-48 transition-all duration-150 ease-in-out`}
                        onClick={() => {
                          setValues({
                            ...values,
                            formMode: 'password',
                            secondPage: false,
                            otp: '',
                          });
                          setErrors({});
                          setError(null);
                        }}
                      >
                        Login With Password
                      </button>
                      <button
                        type="button"
                        className={`${
                          values.formMode === 'otp'
                            ? 'bg-blue-kheloBlue text-white'
                            : 'bg-gray-100 hover:bg-orange-350 hover:text-white'
                        }  p-2 rounded-md w-48 transition-all duration-150 ease-in-out`}
                        onClick={() => {
                          setValues({ ...values, formMode: 'otp', secondPage: false, otp: '' });
                          setErrors({});
                          setError(null);
                        }}
                      >
                        Login With Mobile OTP
                      </button>
                    </div>
                  </div>

                  {values.formMode !== 'otp' || !values.secondPage ? (
                    <Form id="signIn-form">
                      <label className="font-semibold text-sm text-gray-650 pb-2 md:pb-1 block">
                        {values.formMode === 'password' ? 'Email' : 'Mobile Number'}
                      </label>
                      <div className={values.formMode === 'otp' ? 'mb-24 pb-2.5' : ''}>
                        <div className="flex flex-wrap w-full relative bg-white items-center border-2 rounded-lg">
                          <div className="flex justify-center items-center pl-3 w-15">
                            <FontAwesomeIcon
                              icon={values.formMode === 'password' ? faEnvelope : faAddressBook}
                              className="text-gray-450 "
                            />
                          </div>
                          <Field
                            data-cy="signin"
                            type="text"
                            name={values.formMode === 'password' ? `username` : `otpUsername`}
                            placeholder={
                              values.formMode === 'password' ? 'someone@domain.com' : '9898989898'
                            }
                            className="bg-red flex-shrink flex-grow leading-normal w-px flex-1 border-0 p-2 border-grey-400 rounded rounded-l-none px-3 self-center relative font-roboto outline-none"
                          />
                        </div>
                        {values.formMode === 'otp' && !values.secondPage ? (
                          <span className="text-xs my-1">
                            Mobile No: Without Country Code i.e 9898989898
                          </span>
                        ) : null}
                        <ErrorMessage
                          name={values.formMode === 'password' ? `username` : `otpUsername`}
                          component="div"
                          className="flex-1 text-red-400"
                        />
                        {error !== null && values.formMode === 'otp' ? (
                          <div className="flex-1 text-red-400">{error}</div>
                        ) : null}
                      </div>
                      {values.formMode === 'password' ? (
                        <>
                          <label className="font-semibold text-sm text-gray-650 mt-4  pb-2 md:pb-1 block">
                            Password
                          </label>
                          <div className="flex flex-wrap w-full relative bg-white items-center border-2 rounded-lg">
                            <div className="flex justify-center items-center pl-3 w-15">
                              <FontAwesomeIcon icon={faLock} className="text-gray-450 " />
                            </div>
                            <Field
                              data-cy="password"
                              type={passwordVisible ? 'text' : 'password'}
                              name="password"
                              placeholder="********"
                              className="flex-shrink flex-grow leading-normal w-px flex-1 border-0 p-2 border-grey-400 rounded rounded-l-none px-3 self-center relative font-roboto outline-none"
                            />
                            <div className="flex justify-center items-center pr-3 w-15 ">
                              {passwordVisible ? (
                                <div
                                  className="hover:bg-gray-100 px-2 py-1 rounded-full"
                                  onClick={() => setPasswordVisible(false)}
                                >
                                  <FontAwesomeIcon icon={faEyeSlash} className=" text-gray-450 " />
                                </div>
                              ) : (
                                <div
                                  className="hover:bg-gray-100 px-2 py-1 rounded-full"
                                  onClick={() => setPasswordVisible(true)}
                                >
                                  <FontAwesomeIcon icon={faEye} className=" text-gray-450 " />
                                </div>
                              )}
                            </div>
                          </div>
                          <ErrorMessage
                            name="password"
                            component="div"
                            className="flex-1 text-red-400"
                          />
                        </>
                      ) : null}
                      {error !== null && values.formMode === 'password' ? (
                        <div className="flex-1 text-red-400">{error}</div>
                      ) : null}
                      <div className="w-full flex justify-between text-left mt-5">
                        {/* {isKhelo && (
                    <> */}
                        {/* <div
                            className="cursor-pointer font-bold text-gray-600 hover:bg-gray-100 px-4 py-3 rounded-md"
                            onClick={() => {
                              history.push('/register');
                            }}
                          >
                            Not a member? Create Account
                          </div> */}
                        {/* <button
                        type="button"
                        className={`cursor-pointer hidden text-center md:inline-block reg-btn-outline-dark mr-1 w-1/2 hover:bg-gray-250 font-semibold rounded-lg px-10 py-2 text-gray-dark`}
                        onClick={() => {
                          history.push('/micro-site/221/landing/overview');
                        }}
                        disabled={isSubmitting}
                      >
                        Join As Guest
                      </button> */}
                        {/* </> */}
                        {/* )} */}
                        {values.formMode === 'password' ? (
                          <div
                            className={`cursor-pointer font-bold text-gray-600 ${
                              isKhelo ? 'hover:text-orange-350' : 'hover:bg-gray-100'
                            } px-4 py-3 rounded-md`}
                            onClick={() => {
                              history.push('/forgot-password');
                            }}
                          >
                            Forgot Password?
                          </div>
                        ) : null}
                      </div>
                      <div className="flex center flex-row-reverse md:flex-row 2xl:flex-row justify-center w-full">
                        <button
                          data-cy="submit"
                          type="submit"
                          className={`hidden md:inline-block bg-gray-750 ${
                            isKhelo ? 'hover:bg-orange-350' : 'hover:bg-blue-800'
                          } font-semibold flex-1 ml-1 rounded-lg my-8 px-10 py-2 text-white text-sm `}
                          disabled={isSubmitting}
                        >
                          {values.formMode === 'password' ? 'Sign In' : 'Send OTP'}
                        </button>
                        <button
                          type="button"
                          className={`flex-1 cursor-pointer text-sm text-center hidden md:inline-block mr-1 w-1/2 ${
                            isKhelo
                              ? 'hover:bg-orange-350  bg-blue-kheloBlue text-white'
                              : 'reg-btn-outline-dark  hover:bg-gray-250 text-gray-dark'
                          } font-semibold rounded-lg my-8 px-10 py-2 `}
                          onClick={() => {
                            history.push('/micro-site/221/landing/overview');
                          }}
                          disabled={isSubmitting}
                        >
                          Skip Login
                        </button>
                      </div>
                    </Form>
                  ) : (
                    <Form id="signIn-form" className="max-w-full">
                      <OtpComponent
                        otp={values.otp}
                        setOtp={(value) => setFieldValue('otp', value, true)}
                        username={values.otpUsername}
                        setUsername={(value) => setFieldValue('otpUsername', value, true)}
                        setPage={(value) => setFieldValue('secondPage', value, true)}
                        backCallback={() => setFieldValue('secondPage', false, true)}
                        resendCallback={async () =>
                          await checkUserMutation.mutateAsync({ username: values.otpUsername })
                        }
                      />
                      {error !== null ? <div className="flex-1 text-red-400">{error}</div> : null}
                      <div className="flex center flex-row-reverse md:flex-row 2xl:flex-row justify-center w-full">
                        <button
                          data-cy="submit"
                          type="submit"
                          className={`hidden md:inline-block bg-gray-750 ${
                            isKhelo ? 'hover:bg-orange-350' : 'hover:bg-blue-800'
                          } font-semibold flex-1 ml-1 rounded-lg my-8 px-10 py-2 text-white text-sm `}
                          disabled={isSubmitting}
                        >
                          Sign In
                        </button>
                        <button
                          type="button"
                          className={`flex-1 cursor-pointer text-sm text-center hidden md:inline-block mr-1 w-1/2 ${
                            isKhelo
                              ? 'hover:bg-orange-350  bg-blue-kheloBlue text-white'
                              : 'reg-btn-outline-dark  hover:bg-gray-250 text-gray-dark'
                          } font-semibold rounded-lg my-8 px-10 py-2 `}
                          onClick={() => {
                            history.push('/micro-site/221/landing/overview');
                          }}
                          disabled={isSubmitting}
                        >
                          Skip Login
                        </button>
                      </div>
                    </Form>
                  )}
                  {/* <p className="text-gray-700 hidden">
                    <a href="#">Privacy Policy</a> and <a href="#">Terms & Conditions</a> apply
                  </p> */}
                </div>
              </div>
              <Footer2ButtonAuth
                // nextButtonText={cartSummary.data ? `Pay ₹ ${cartSummary.data?.to_be_paid}` : 'Loading...'}
                onCreate={() => {
                  history.push(`/micro-site/221/landing/overview`);
                }}
                customPrimaryText={
                  values.formMode === 'otp' && !values.secondPage ? 'Send OTP' : 'Sign In'
                }
                isSubmitting={isSubmitting}
                // isLoading={isPaymentLoading}
              />
            </div>
          )}
        </Formik>
      )}
    </>
  );
}
